import { IgNudgeAlert } from "@intelligems/ig-theme";
import { useIsStaleVersion } from "@src/api/versions/use-version-check";
import { useEffect, useState } from "react";

export const UpdateAvailableNudge = () => {
  const { isStaleNudge } = useIsStaleVersion();
  const [showAfterDelay, setShowAfterDelay] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAfterDelay(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  if (!isStaleNudge || !showAfterDelay) {
    return null;
  }

  return (
    <IgNudgeAlert
      title="Update available"
      description="Access the latest features."
      action={{
        label: "Refresh",
        color: "primary",
        variant: "contained",
        onClick: () => window.location.reload(),
      }}
    />
  );
};
